import { render, staticRenderFns } from "./AppHeader4.vue?vue&type=template&id=07e8aec2"
import script from "./AppHeader4.vue?vue&type=script&lang=ts"
export * from "./AppHeader4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports